import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Button, Row } from "antd";
import {
  SubscriptionLevel,
  ValimateConfigurationResultDto,
  ValimateExecutionStatus,
  ValimateTestCaseResultDto,
} from "../../autogenerated/models";
import {
  DowloadExecutionReport,
  DownloadExecutionSummaryReport,
} from "../../store/api";
import { rerunTest, setIsDownloading } from "../../store/slices/valimateSlice";
import FileDownload from "js-file-download";
import { ApplicationState } from "../../store";
import { FileExcelOutlined, RedoOutlined } from "@ant-design/icons";

interface TucResultActionsProps {
  configurationResult: ValimateConfigurationResultDto;
  result: ValimateTestCaseResultDto;
  enableReruns: boolean;
  rerunning: boolean;
  downloading: boolean;
  sessionId: string;
}

const TucResultActions: React.FC<TucResultActionsProps> = ({
  configurationResult = {},
  result = {},
  enableReruns = false,
  rerunning = false,
  downloading = false,
  sessionId = "",
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state: ApplicationState) => state.init.data.user);

  const DowloadReport = useCallback(
    (runId, fileName) => {
      dispatch(setIsDownloading(true));
      DowloadExecutionReport(runId)
        .then((response: Blob) => {
          if (response && response.size > 0)
            FileDownload(response, `${fileName}_${Date.now()}.zip`);
        })
        .finally(() => dispatch(setIsDownloading(false)));
    },
    [dispatch]
  );

  const DowloadSummary = useCallback(
    (runId, fileName) => {
      dispatch(setIsDownloading(true));
      DownloadExecutionSummaryReport(runId)
        .then((response: Blob) => {
          if (response && response.size > 0)
            FileDownload(response, `${fileName}_${Date.now()}.xlsx`);
        })
        .finally(() => dispatch(setIsDownloading(false)));
    },
    [dispatch]
  );

  const RerunTestCase = useCallback(
    (sessionId: string, testCaseId: string, configurationId: string) =>
      dispatch(rerunTest(sessionId, testCaseId, configurationId)),
    [dispatch]
  );

  let canDownloadRepots =
    user?.wasPaidSubscriber ||
    user?.subscription === SubscriptionLevel.Basic ||
    user?.subscription === SubscriptionLevel.Incremental ||
    user?.subscription === SubscriptionLevel.Advanced;

  return (
    <Col span={12}>
      {enableReruns &&
      configurationResult.execution?.status ===
        ValimateExecutionStatus.Inconclusive ? (
        <Button
          loading={rerunning}
          disabled={rerunning}
          icon={<RedoOutlined />}
          onClick={() =>
            RerunTestCase(
              sessionId,
              result.testCase?.id ?? "",
              configurationResult.testConfiguration?.id ?? ""
            )
          }
        >
          Re-run step
        </Button>
      ) : (
        ""
      )}
      {configurationResult.execution?.status ===
        ValimateExecutionStatus.Passed ||
      configurationResult.execution?.status ===
        ValimateExecutionStatus.Failed ? (
        <>
          {!canDownloadRepots ? (
            <Row>
              <Col span={24}>Requires paid subscription</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col span={24}>
              <Button
                disabled={!canDownloadRepots}
                loading={downloading}
                icon={<FileExcelOutlined />}
                onClick={() =>
                  DowloadSummary(
                    configurationResult.execution?.id,
                    `Summary_${result.testCase?.identifier}_${configurationResult.testConfiguration?.name}`
                  )
                }
              >
                Download Summary{" "}
              </Button>
              <Button
                disabled={!canDownloadRepots}
                loading={downloading}
                icon={<FileExcelOutlined />}
                onClick={() =>
                  DowloadReport(
                    configurationResult.execution?.id,
                    `${result.testCase?.identifier}_${configurationResult.testConfiguration?.name}`
                  )
                }
              >
                Download Full Report{" "}
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
    </Col>
  );
};

export default TucResultActions;
